<template>
  <Modal
    dusk="update-resource-modal"
    :show="show"
    @close-via-escape="handlePreventModalAbandonmentOnClose"
    :size="size"
    :use-focus-trap="false"
  >
    <div
      class="bg-gray-100 dark:bg-gray-700 rounded-lg shadow-lg overflow-hidden p-8"
    >
      <UpdateResource
        ref="updateResource"
        :resource-name="resourceName"
        :resource-id="resourceId"
        via-relationship=""
        via-resource-id=""
        via-resource=""
      />
    </div>
  </Modal>
</template>

<script>
import { PreventsModalAbandonment } from '@/mixins'
import UpdateResource from '@/views/Update'

export default {
  emits: ['resource-updated', 'update-cancelled'],

  mixins: [PreventsModalAbandonment],

  components: {
    UpdateResource,
  },

  props: {
    show: { type: Boolean, default: false },
    size: { type: String, default: '6xl' },
    resourceName: {
      type: String,
      required: true
    },
    resourceId: {
      type: [String, Number],
      required: true
    },
  },

  watch: {
    show(newVal) {
      if (newVal) {
        // Listen for Nova resource-updated event
        Nova.$on('resource-updated', this.handleResourceUpdated)
      } else {
        Nova.$off('resource-updated', this.handleResourceUpdated)
      }
    }
  },

  methods: {
    handleResourceUpdated(data) {
      // Only handle if it's for this resource
      if (data.resourceName === this.resourceName && 
          data.resourceId.toString() === this.resourceId.toString()) {
        this.$emit('resource-updated', data)
        this.handleUpdateCancelled()
      }
    },

    handleUpdateCancelled() {
      return this.$emit('update-cancelled')
    },

    handlePreventModalAbandonmentOnClose(event) {
      this.handlePreventModalAbandonment(
        () => {
          this.handleUpdateCancelled()
        },
        () => {
          event.stopPropagation()
        }
      )
    },
  },

  beforeUnmount() {
    Nova.$off('resource-updated', this.handleResourceUpdated)
  },
}
</script>

